import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfo } from 'backend/subcategories';

interface ISuggestedDishSubCategorySelect {
	setFetchedSuggestedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	selectedSuggestedDishCategory: Nullable<string>;
}

const SuggestedDishSubCategorySelect: React.FC<ISuggestedDishSubCategorySelect> = ({
	setFetchedSuggestedDishSubCategories,
	setSuggestedDishSubCategory,
	selectedSuggestedDishCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		selectedSuggestedDishCategory ? getSubCategoriesShortInfo : null,
		selectedSuggestedDishCategory ? [selectedSuggestedDishCategory] : [],
	);

	useEffect(() => {
		refetch();
	}, [selectedSuggestedDishCategory]);

	useEffect(() => {
		response && setFetchedSuggestedDishSubCategories(response.data.subCategories);
	}, [response]);

	return (
		<FormSelect
			name="selectedSuggestedDishSubCategory"
			label="subcategoryLabel"
			options={response?.data.subCategories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!selectedSuggestedDishCategory || loading}
			onChange={setSuggestedDishSubCategory}
		/>
	);
};

export default React.memo(SuggestedDishSubCategorySelect);
